import React from 'react'
import CommonPaymentAddEditVerify from './CommonPaymentAddEditVerify';
import { PROD } from '../../common/constants';

function AdvancePaymentAddEditVerify() {

  return (
    <div>
      {!PROD && <p style={{ textAlign: "right", fontSize: "2vh" }}>PAY02</p>}
      <CommonPaymentAddEditVerify paymentType="Advance" />
    </div>

  )
}

export default AdvancePaymentAddEditVerify;